import ApiClient, { createFetchErrorMessage } from '../../../utils/api/ApiClient';
import { createSlice } from '@reduxjs/toolkit';


const initialState = { loading:true, result:null, message:null };
const userRecommendSlice = createSlice({
    name: 'userRecommend',
    initialState,
    reducers: {
        loading: (state) => initialState,
        fetch: (state, action) => {
            state.loading = false;
            state.listHelp = action.payload.listHelp;
            state.listLike = action.payload.listLike;
        },
        error: (state, action) => {
            state.loading = false;
            state.message = action.payload;
        }
    }
});


export default userRecommendSlice.reducer;
export const userRecommendActions = userRecommendSlice.actions;


let userRecommendCancel;
export function fetchUserUserRecommend() {
	return function (dispatch) {
		dispatch( userRecommendActions.loading() );
        if(userRecommendCancel!==undefined) userRecommendCancel();
        
        const { promise, cancel } = ApiClient({
            method: 'POST',
			url: '/api/recommend/user',
            authToken:sessionStorage.getItem('user')
        });
		userRecommendCancel = cancel;
        promise.then(res => {
			dispatch( userRecommendActions.fetch(res.data) );
		}).catch((err) => {
            const errorData = createFetchErrorMessage(err, '맞춤추천 생성에 실패했습니다.');
            dispatch( userRecommendActions.error(errorData.message) );
		});
	}// return
}